// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1-sxh","title":"FrontImage_title__G3WYd"};